import React from "react"
import {iconArrowToLeft, iconArrowToRight} from "../../Helper/Icons"
import {layoutSidebarRightWidth} from "../../settings"
import style from "./SideBarRightHandel.css"

export const SideBarRightHandel = ({children, sidebar}) => {
    const className = sidebar.isDisable()
        ? style.containerDisabled
        : (sidebar.isOpen() ? style.container : style.containerClose)

    const toggleView = () => {
        sidebar.toggle()
    }

    return <div className={className} style={{width: `${layoutSidebarRightWidth}px`}}>
        <div style={{width: `${layoutSidebarRightWidth}px`}}>
            <div style={{width: `${layoutSidebarRightWidth}px`}}>
                {children}
            </div>
        </div>
        <Handle isOpen={sidebar.isOpen()} onClick={toggleView}/>
    </div>
}

const Handle = ({isOpen, onClick}) => {
    const handleIcon = isOpen ? iconArrowToRight : iconArrowToLeft

    return <div className={style.handle} onClick={onClick}>{handleIcon}</div>
}



